import { apiService } from '../../../core/api/BaseApiService';

export interface ChangePasswordPayload {
  userId:      string;
  oldPassword: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  isSuccess:  boolean;
  statusCode: number;
  response:   object;
  error:      null | string;
  message:    string;
}

/**
 * POST /user/change-password
 * Authorization: Bearer <access_token>
 */
export const changePassword = (
  payload: ChangePasswordPayload
): Promise<ChangePasswordResponse> =>
  apiService.post<ChangePasswordResponse>('/user/change-password', payload);
